__turbopack_context__.v({
  "button": "ResultsSummary-module-scss-module__XVNfua__button",
  "header": "ResultsSummary-module-scss-module__XVNfua__header",
  "main": "ResultsSummary-module-scss-module__XVNfua__main",
  "not-selected": "ResultsSummary-module-scss-module__XVNfua__not-selected",
  "options": "ResultsSummary-module-scss-module__XVNfua__options",
  "selected": "ResultsSummary-module-scss-module__XVNfua__selected",
});
